var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.destination)?_c('router-link',{attrs:{"to":_vm.destination,"aria-label":'Abrir graficador de ' + _vm.ticker}},[_vm._t("default",[_vm._v("Ver gráfico")]),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v(" ↗")])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }